

export default function AppWrapper(props: React.PropsWithChildren) {
    return <>
        {props.children}
    </>;
}